"use client";

import * as React from "react";
import { useTheme } from "next-themes";

// Keep the retired, ungated "theme" key separate from the current preference.
// Light-only routes are enforced by ThemeProvider's forcedTheme, never by stored preferences.
export const THEME_STORAGE_KEY = "brev-color-theme";
export type ThemePreference = "system" | "light" | "dark";
export const ThemeAccessContext = React.createContext({
  enabled: false,
  /** Pins one theme for the page without touching the stored preference (the design-system gallery). */
  setForced: (_theme: "light" | "dark" | null) => {}
});

export function useAppTheme() {
  const { enabled } = React.useContext(ThemeAccessContext);
  const { theme, resolvedTheme, forcedTheme, setTheme } = useTheme();
  return {
    enabled,
    preference: theme === "light" || theme === "dark" ? theme : "system",
    // A forced theme wins: "light" on light-only routes, or the gallery's ThemeForce.
    isDark: (forcedTheme ?? (enabled ? resolvedTheme : "light")) === "dark",
    setPreference: (preference: ThemePreference) => {
      if (enabled) setTheme(preference);
    }
  };
}
